// extracted by mini-css-extract-plugin
module.exports = {"cell":"EmployeeTable_cell_2rXWr","badge":"EmployeeTable_badge_1FeH-"};